<app-titled-page heading="Inicios de sesión">
  <router-outlet></router-outlet>
</app-titled-page>
